import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { IUser } from '../../reducers/Reducers.interfaces'
import { IAppState } from '../../core/store/store'
import { RouterConfig } from 'core/utils/constants'
import history from 'core/history/history'
import { LocalizeContextProps, withLocalize } from 'react-localize-redux'

interface IProps extends RouteComponentProps, LocalizeContextProps {
  profile?: IUser
}

const Profile = (props: IProps) => {
  const {profile, setActiveLanguage} = props
  useEffect(() => {
    if (profile?.id) {
      if (profile.locale) {
        setActiveLanguage(profile.locale.split('_')[0])
      }
      history.push(RouterConfig.administrators.details(profile.id))
    }
  }, [profile, setActiveLanguage])
  return (
    <>
    </>
  )
}

export default connect(
  (state: IAppState) => {
    return {
      profile: state.profile.data
    }
  },
  {}
)(withLocalize(Profile))
